// LIBRERIE/IMPORTS
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouseChimney, faUserTie, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

//COMPONENTI
import ServiceCard from "./ServiceCard";

const ServicesSection: React.FC = () => {
    const { t } = useTranslation();

    const services = [
        {
            "title": t('homePage.servicesSection2.serviceTitle1'),
            "icon": <FontAwesomeIcon icon={faHouseChimney} />,
            "description": t('homePage.servicesSection2.description1'),
            "link": "/valutazione",
            "label": t('navigation.valutationLinkTitle')
        },
        {
            "title": t('homePage.servicesSection2.serviceTitle2'),
            "icon": <FontAwesomeIcon icon={faUserTie} />,
            "description": t('homePage.servicesSection2.description2'),
            "link": "/servizi",
            "label": t('navigation.servicesLinkTitle')
        },
        {
            "title": t('homePage.servicesSection2.serviceTitle3'),
            "icon": <FontAwesomeIcon icon={faGlobe} />,
            "description": t('homePage.servicesSection2.description3'),
            "link": "/contatti",
            "label": t('navigation.contactUsLinkTitle')
        }
    ];

    return (
        <section className="space-ptb" id="agency-services-vetrina">
            <div className="container-fluid w-90">
                <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.servicesSection2.title') as string }} />
                <div className="row justify-content-center text-center">
                    {services.map((service, index) => (
                        <ServiceCard key={index}
                            serviceId={index}
                            service={service}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;